import React from 'react';
import {DatePicker} from 'antd';
import commonExtendsHOC from '../../commonExtendsHOC';
//import {IsIE9} from "../../../common/utils/IsIE";

const {RangePicker}=DatePicker;

export default commonExtendsHOC(DatePicker);



// export default class AisinoDatePicker extends React.Component {
//     constructor(props){
//         super(props)
//         this.state={
//             dropdownClassName:IsIE9()?"":"date-picker-selector-hide"
//         }
//     }
//     onFocus(e){
//         this.setState({dropdownClassName:"date-picker-selector-show"});
//         if(this.props.onFocus!=null)
//             this.props.onFocus(e);
//         return;
//     }
//     onBlur(e){
//         if(this.props.onBlur!=null)
//             this.props.onBlur(e);
//         this.setState({dropdownClassName:"date-picker-selector-hide"});
//         return;
//     }
//     onChange(e){
//         console.log(e)
//         if(this.props.onChange!=null)
//             this.props.onChange(e);
//         this.setState({dropdownClassName:"date-picker-selector-hide"});
//         this.refs.datePicker.blur();
//         return;
//     }
//     render(){
//
//         return(<DatePicker ref={"datePicker"} open={true} {...this.props}
//                            onFocus={this.onFocus.bind(this)}
//                            onBlur={this.onBlur.bind(this)}
//                            onChange={this.onChange.bind(this)}
//                            dropdownClassName={this.state.dropdownClassName} />)
//     }
// }
//
export const AisinoRangePicker=commonExtendsHOC(RangePicker);
